// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"477d7b0b","270":"ba825c98","345":"dfc3787a","377":"60a53188","601":"64a6381a","615":"8e103aa0","658":"7375213d","693":"d926dbbc","717":"18493d66","726":"25d6d7a9","746":"87d35f7b","787":"75003648","794":"33fc8a29","800":"ad0d705e","933":"86ccab3f","969":"35c706ae"}[chunkId] + ".chunk.js";
};